import React , {Component} from 'react';
import {
    Page , Toolbar , Link , Tabs , Tab , Popup , Navbar , NavRight
} from 'framework7-react';
import * as axios from "axios/index";
import BranchLoader from './../Loader/BrancLoader';
import FoodCard from "../Cards/FoodCard";
import star from './../images/star.svg';
import * as vars from './Vars';

import { connect } from "react-redux";
import {
    addToUserCart,
    removeFromUserCart,
    addToCart,
    receiveProducts,
    removeFromCart,
    receiveCart,
    receiveBranch,
    resetCart,
    toolbar ,
} from "../actions";

class BranchShow extends Component{


    componentDidMount() {

        let data = new FormData()
        data.append('user_app_version' , '100' )
        data.append('a_token' , 'webapp' )
        data.append('mobile' , localStorage.getItem('mobile') )
        data.append('imei_code' , localStorage.getItem('imeiCode') )
        data.append('users_ID' , localStorage.getItem('users_ID') )
        data.append('branchs_ID' , this.state.branchId )
        data.append('feedback' , 1 )

        axios.post( vars.PreUrl +  'https://www.lavefood.com/v2/foods' ,
            data )
            .then(response => {
                let data = response.data.result[0]
                // console.log(data)
                if(data.error === 0)
                {
                    this.props.receiveProducts(data.foods)
                    if (this.props.branch.ID !== data.branch.ID)
                        this.props.resetCart([])
                    else
                        this.props.receiveCart([])

                    this.props.receiveBranch(data.branch)

                    this.setState({
                        requestLoading : false ,
                        foods : data.foods ,
                        branch : data.branch ,
                        feedback : data.feedback ,
                        categories : data.categories ,
                    })

                }
                else
                {
                    this.$f7router.navigate('/')
                    return false
                }


            })
            .catch(error => {
                console.log(error)
            })
    }


    constructor(props) {
        super(props);
        let branchId = props.f7route.params.branchId;
        this.state = {
            requestLoading : true ,
            branch : [] ,
            foods : [] ,
            feedback : [] ,
            branchId : branchId ,
            categories : [] ,
            detailsShow : false ,
            commentsShow : false
        }
    }

    onPageBeforeIn(){
        this.props.toolbar(false)
    }


    render(){

        const {addToCart , removeFromCart , products , addToUserCart , removeFromUserCart , cart , branch } = this.props

        let cartCount = 0
        if (this.state.requestLoading === false)
        {
            cart.forEach(function ( item ) {
                cartCount += item
            })
        }

        let maxBranchDiscount = 0
        if (branch.length !== 0)
        {
            branch.discounts.map((item , index)=> {
                if (parseInt(item.percent_branchs) > maxBranchDiscount)
                {
                    maxBranchDiscount = parseInt(item.percent_branchs)
                }
                if (parseInt(item.percent_app) > maxBranchDiscount)
                {
                    maxBranchDiscount = parseInt(item.percent_app)
                }
            })
        }



        return(



            <Page name="BranchShow" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>
                {

                    this.state.requestLoading === true ? (
                        <BranchLoader  />
                    ) : (



                            <div className="h-100 overflow-y-scroll overflow-x-scroll">
                                <div id="branch-header">

                                    <Link back id="back"  >
                                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                                    </Link>

                                    <img className="img-cover" src={this.state.branch.imgurl} />
                                    <div className="logo-container">
                                        <img className="logo" src={this.state.branch.imgurl} />
                                        <span className="rate">
                                            {this.state.branch.rate}
                                            <img src={star}/>
                                        </span>
                                    </div>
                                    <div className="details">
                                        <div className="title">
                                            {this.state.branch.title_fa}
                                            {
                                                maxBranchDiscount > 0 ? (
                                                    <span className="status">
                                                        {maxBranchDiscount}
                                                        %
                                                    </span>
                                                ) : (``)
                                            }

                                        </div>
                                        <div className="branch-status">
                                            {
                                                this.state.branch.active === true ? (

                                                    <span className="text online">
                                                        آماده سرویس دهی
                                                    </span>
                                                ):(
                                                    <span className="text offline">
                                                        رستوران آفلاین می باشد
                                                    </span>
                                                )
                                            }
                                        </div>
                                        <div className="time">
                                            <span className="text">
                                                {this.state.branch.time_X_title_fa}
                                            </span>

                                        </div>
                                        <div className="delivery-time">
                                            <span className="text">
                                                {this.state.branch.delivery_time_text}
                                            </span>
                                        </div>


                                    </div>
                                    <div className="b-row justify-content-end no-gutters align-items-center" id="more-details-container">
                                        <div className="b-col-3 text-center">
                                            <div id="more-details" onClick={() => this.setState({commentsShow : true})}>
                                                <i className="fas fa-comment"></i>
                                            </div>
                                        </div>

                                        <div className="b-col-3 text-center">
                                            <div id="more-details" onClick={() => this.setState({detailsShow : true})}>
                                                <i className="fas fa-info-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Toolbar tabbar scrollable top id="category-toolbar">
                                    <Link tabLink="#tab-all" tabLinkActive>همه</Link>
                                    {this.state.categories.map((item , index)=>(
                                        <Link tabLink={`#tab-${item.ID}`} key={index}>{item.title_fa}</Link>
                                    ))}
                                </Toolbar>
                                <Tabs >

                                    <Tab id="tab-all" className="page-content" tabActive>
                                        {this.state.foods.map((food , index)=> (
                                            <FoodCard key={index} object={products[food.ID]} count={ !isNaN(cart[food.ID]) || cart[food.ID] !== undefined ? cart[food.ID] : 0} selected={cart[food.ID] !== undefined} onRemoveFromCartClicked={() => [removeFromCart(food.ID) , removeFromUserCart(food.ID)]} onAddToCartClicked={() => [addToCart(food.ID) ,addToUserCart(food.ID)]} />
                                        ))}
                                    </Tab>


                                    {this.state.categories.map((category , categoryIndex)=>(
                                        <Tab id={`tab-${category.ID}`} className="page-content" key={categoryIndex}>
                                            {this.state.foods.map((food , foodIndex)=> (
                                                food.categories_ID.map((foodCategory , foodCategoryIndex)=>(
                                                    foodCategory.ID === category.ID ? (
                                                        <FoodCard key={foodIndex} object={products[food.ID]} count={ !isNaN(cart[food.ID]) || cart[food.ID] !== undefined ? cart[food.ID] : 0} selected={cart[food.ID] !== undefined}   onRemoveFromCartClicked={() => [removeFromCart(food.ID) , removeFromUserCart(food.ID)]} onAddToCartClicked={() => [addToCart(food.ID) ,addToUserCart(food.ID)]} />
                                                    ) : (
                                                        ``
                                                    )

                                                ))
                                            ))}
                                        </Tab>
                                    ))}

                                </Tabs>

                                <Link href="/cart/" id="basket" className={cartCount === 0 ? "disabled" : ""}  disabled={cartCount === 0} >
                                    <img src="https://razeghiadmin.ir/images/icons/basket.svg" alt="basket"/>
                                    <span className="count">{cartCount}</span>
                                </Link>

                            </div>


                    )
                }


                {/*<AppToolbar />*/}

                <Popup id="comments-details-popup" swipeToClose opened={this.state.commentsShow} onPopupClosed={() => this.setState({commentsShow : false})}>
                    <Page>
                        <Navbar title="نظرات">
                            <NavRight>
                                <Link popupClose>بستن</Link>
                            </NavRight>
                        </Navbar>

                        <div   style={{paddingTop: "100px"}}>


                            <div className="item  text-right direction-rtl"  >
                                {this.state.feedback.map((cmnt , cmntIndex)=> (
                                    <div className="item  p-3  mb-2" key={cmntIndex} style={{borderBottom: "1px solid #ccc"}}>

                                        <div className="name mb-1" style={{ color : "#5d5d5d" }}>
                                            { cmnt.users_name }
                                        </div>
                                        <div className="text mb-2">
                                            { cmnt.text }
                                        </div>
                                        <div className="date mb-1" style={{ color : "#5d5d5d" }}>
                                            { cmnt.created_at_date }
                                        </div>
                                    </div>

                                ))}
                            </div>




                        </div>
                    </Page>
                </Popup>

                <Popup id="more-details-popup" swipeToClose opened={this.state.detailsShow} onPopupClosed={() => this.setState({detailsShow : false})}>
                    <Page>
                        <Navbar title="جزئیات">
                            <NavRight>
                                <Link popupClose>بستن</Link>
                            </NavRight>
                        </Navbar>

                        <div className="display-flex justify-content-center align-items-center h-100">


                            <div className="items">
                                <div className="item">
                                    <span className="title">ساعت سرویس دهی :</span>
                                    <span className="content">{ this.state.branch.service_time_text }</span>

                                </div>
                                <div className="item">
                                    <span className="title">توضیحات رستوران :</span>
                                    <span className="content">{ this.state.branch.details }</span>
                                </div>
                                <div className="item">
                                    <span className="title">آدرس :</span>
                                    <span className="content">{ this.state.branch.address }</span>
                                </div>
                                <div className="item">
                                    <span className="title">حداقل سفارش :</span>
                                    <span className="content">{ this.state.branch.price_min }</span>
                                </div>
                            </div>




                        </div>
                    </Page>
                </Popup>
            </Page>





        )
    }
}

const mapDispatchToProps = dispatch => ({
    receiveProducts : products => dispatch(receiveProducts(products)) ,
    addToCart : productId => dispatch(addToCart(productId)) ,
    removeFromCart : productId => dispatch(removeFromCart(productId)) ,


    resetCart : cart => dispatch(resetCart(cart)) ,
    receiveCart : cart => dispatch(receiveCart(cart)) ,
    addToUserCart : productId => dispatch(addToUserCart(productId)) ,

    removeFromUserCart : productId => dispatch(removeFromUserCart(productId)) ,



    receiveBranch : branch => dispatch(receiveBranch(branch)) ,


    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
        branch : state.branch,
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(BranchShow);